import DatePickerFilter from './DatePickerFilter';
import TextInputFilter from './TextInputFilter';

const dataTypesFilterComponentsMap = {
  'System.String': TextInputFilter,
  'System.DateTime': DatePickerFilter,
};

export const getFilterComponentByDataType = (dataType) =>
  dataTypesFilterComponentsMap[dataType] || TextInputFilter;
